// extracted by mini-css-extract-plugin
export default {"root":"InfoItem_root__18k8P","num":"InfoItem_num__HJy6X","list":"InfoItem_list__3xEzA","placeHolderShimmer":"InfoItem_placeHolderShimmer__irwsc"};